/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface AppointmentClassRoomRequest
 */
export interface AppointmentClassRoomRequest {
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentClassRoomRequest
     */
    classRoomId: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof AppointmentClassRoomRequest
     */
    priority: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the AppointmentClassRoomRequest interface.
 */
export function instanceOfAppointmentClassRoomRequest(value: object): value is AppointmentClassRoomRequest {
    if (!('classRoomId' in value) || value['classRoomId'] === undefined) return false;
    if (!('priority' in value) || value['priority'] === undefined) return false;
    return true;
}

export function AppointmentClassRoomRequestFromJSON(json: any): AppointmentClassRoomRequest {
    return AppointmentClassRoomRequestFromJSONTyped(json, false);
}

export function AppointmentClassRoomRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AppointmentClassRoomRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'classRoomId': ApiUserTasksGetPageParameterFromJSON(json['classRoomId']),
        'priority': ApiUserTasksGetPageParameterFromJSON(json['priority']),
    };
}

export function AppointmentClassRoomRequestToJSON(json: any): AppointmentClassRoomRequest {
    return AppointmentClassRoomRequestToJSONTyped(json, false);
}

export function AppointmentClassRoomRequestToJSONTyped(value?: AppointmentClassRoomRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'classRoomId': ApiUserTasksGetPageParameterToJSON(value['classRoomId']),
        'priority': ApiUserTasksGetPageParameterToJSON(value['priority']),
    };
}

